<template lang="html">
    <div>
        <div id="content" class="app-content box-shadow-z0" role="main">
            <div class="app-header grey-200 box-shadow">
                <div class="navbar navbar-expand-lg navbar-light bg-light">
                    <router-link to="/" class="navbar-brand">Telemetry</router-link>
                    <ul class="nav navbar-nav">
                        <li class="nav-item dropdown">
                            <a data-toggle="dropdown" class="nav-link dropdown-toggle">Panolar</a>
                            <ul class="dropdown-menu" style="width: 300px;">
                                <li v-if="hasPermission('dashboards.save')">
                                    <router-link to="/dashboards/save" exact>Ekle</router-link>
                                </li>
                                <li v-if="hasPermission('dashboards.list')">
                                    <router-link to="/dashboards" exact>Listele</router-link>
                                </li>
                                <li class="divider" v-if="hasPermission('dashboards.list') || hasPermission('dashboards.save')"></li>
                                <li v-for="dashboard in dashboards" v-if="dashboardLoading == false">
                                    <router-link :to="{'path': '/dashboards/' + dashboard.className, query: {id: dashboard.id}}">{{ dashboard.title }}</router-link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" v-if="hasPermission('services.save') || hasPermission('services.list')">
                            <a data-toggle="dropdown" class="nav-link dropdown-toggle">Servisler</a>
                            <ul class="dropdown-menu">
                                <li v-if="hasPermission('services.save')">
                                    <router-link to="/services/save" exact>Ekle</router-link>
                                </li>
                                <li v-if="hasPermission('services.list')">
                                    <router-link to="/services" exact>Listele</router-link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" v-if="hasPermission('users.save') || hasPermission('users.list')">
                            <a data-toggle="dropdown" class="nav-link dropdown-toggle">Kullanıcılar</a>
                            <ul class="dropdown-menu">
                                <li v-if="hasPermission('users.save')">
                                    <router-link to="/users/save" exact>Ekle</router-link>
                                </li>
                                <li v-if="hasPermission('users.list')">
                                    <router-link to="/users" exact>Listele</router-link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" v-if="hasPermission('api_users.save') || hasPermission('api_users.list')">
                            <a data-toggle="dropdown" class="nav-link dropdown-toggle">Api Kullanıcıları</a>
                            <ul class="dropdown-menu">
                                <li v-if="hasPermission('api_users.save')">
                                    <router-link to="/api-users/save" exact>Ekle</router-link>
                                </li>
                                <li v-if="hasPermission('api_users.list')">
                                    <router-link to="/api-users" exact>Listele</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="nav navbar-nav pull-right">
                        <li class="nav-item">
                            <a v-on:click="refreshDashboards()" class="nav-link small" v-if="dashboardLoading == false">Panoları Yenile</a>
                            <span v-if="dashboardLoading == true" class="nav-link small">Panolar Yenileniyor...</span>
                        </li>
                        <li class="nav-item"><span class="nav-link small">|</span></li>
                        <li class="nav-item dropdown">
                            <a data-toggle="dropdown" class="nav-link dropdown-toggle small">{{ timezone }}</a>
                            <ul class="dropdown-menu pull-right">
                                <li>
                                    <a v-on:click="changeTimezone('UTC')">UTC</a>
                                </li>
                                <li>
                                    <a v-on:click="changeTimezone('Europe/Istanbul')">Europe/Istanbul</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link clear" href data-toggle="dropdown">
                                <span class="avatar w-32">
                                    <img src="/assets/images/profile.png" />
                                    <i class="on b-white bottom"></i>
                                </span>
                            </a>
                            <ul class="dropdown-menu pull-right">
                                <li><router-link :to="{path: '/users/save', query: {id: currentUser.id}}">Bilgilerim</router-link></li>
                                <li><a v-on:click="logout">Oturumu Kapat</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="app-footer">
                <div class="p-a text-xs">
                    <div class="pull-right text-muted">
                        &copy; Copyright <strong>Teknasyon</strong>
                        <a ui-scroll-to="content"><i class="fa fa-long-arrow-up p-x-sm"></i></a>
                    </div>
                </div>
            </div>
            <div id="view" class="app-body">
                <div class="blue box-shadow" style="padding-left: 20px; padding-top:10px; padding-bottom: 10px;">
                    <strong style="padding: 0px; font-weight: 500; font-size: 16px;"><slot name="title"></slot></strong>
                </div>
                <div class="padding">
                    <slot name="loading" v-if="loading">
                        <div style="text-align:center">
                            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </slot>
                    <slot name="content" v-if="loading == false"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'bootstrap/js/src/modal.js';
import 'bootstrap/js/src/dropdown.js';
import 'bootstrap/scss/bootstrap.scss';
import 'font-awesome/css/font-awesome.css';
import '../template/app.css';

export default {
    data: function () {
        return {
            dashboards: [],
            currentUser: {
                id: 0
            },
            dashboardLoading: false,
            menuFolded: false,
            timezone: ''
        };
    },
    props: ['loading'],
    created: function () {
        this.currentUser = this.$app.getUser();
        this.dashboards = this.currentUser.dashboards;
    },
    mounted: function () {
        this.timezone = this.$app.getTimezone();
        try {
            $("a[href='#" + this.$route.path + "']").parents('li').eq(1).addClass('active');
        } catch (err) {}
        var cacheMenuFolded = this.$app.getValue('menuFolded');
        if (cacheMenuFolded !== null) {
            this.menuFolded = cacheMenuFolded;
        } else {
            this.menuFolded = false;
        }
    },
    methods: {
        changeTimezone: function (timezone) {
            this.$app.setTimezone(timezone);
            this.timezone = timezone;
            this.$app.eventBus.$emit('timezone-changed');
        },
        hasPermission: function (permission) {
            return this.$app.hasPermission(permission);
        },
        show: function (e) {
            var $this = $(e.target), $active, $li;
            $this.is('a') || ($this = $this.closest('a'));
            $li = $this.parent();
            $active = $li.siblings( ".active" );
            $li.toggleClass('active');
            $active.removeClass('active');
        },
        logout: function () {
            this.$app.clear();
            this.$router.push('/login');
        },
        refreshDashboards: function () {
            var $this = this;
            this.dashboardLoading = true;
            this.$app.get('/api/v1/users/' + this.currentUser.id + '/dashboards', function(xhr) {
                var response = xhr.responseJSON;
                $this.$app.updateDashboards(response.dashboards);
                $this.dashboards = response.dashboards;
                $this.dashboardLoading = false;
            });
        },
        toggleMenu: function () {
            if (this.menuFolded) {
                this.menuFolded = false;
            } else {
                this.menuFolded = true;
            }
            this.$app.setValue('menuFolded', this.menuFolded);
        }
    },
    watch: {
        'menuFolded': function () {
            if (this.menuFolded) {
                $('#aside').addClass('folded');
                $('.navbar-brand span').hide();
            } else {
                $('#aside').removeClass('folded');
                $('.navbar-brand span').show();
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// app_layout.vue?bd7a5dee